import React from "react";

import { Typography } from "@material-ui/core";

import { StyledPage } from "../../Styled-Components/styles";

const ThankYou = () => {
  return (
    <StyledPage>
      <Typography variant="h1" gutterBottom>
        Your payment was successful
      </Typography>

      <Typography variant="body1" gutterBottom>
        I will be building this page in the future if people like you are
        actually supporting the project! I will be building this page in the
        future if people like you are actually supporting the project!
      </Typography>

      <Typography variant="h4" gutterBottom>
        So thank you for being early 💚
      </Typography>
    </StyledPage>
  );
};

export default ThankYou;
